import loadScript from 'load-script';

/**
 * This is copied over from the legacy @origin-digital/geotargetting library.
 *
 * @typedef {Object} geoTargetResponseSubdivision
 * @property {(number|string)} geoname_id
 * @property {string} iso_code - the short name of the subdivision
 * @property {Object} names - names of the subdivision in top languages
 */

/**
 * @typedef {Object} geoTargetResponse
 * @property {Object} city
 * @property {Object} continent
 * @property {Object} country
 * @property {Object} location
 * @property {Object} postal
 * @property {string} postal.code - the user's postcode
 * @property {Array.<geoTargetResponseSubdivision>} subdivisions
 */

/**
 * Globally install the MaxMind GeoIP script for use
 * @returns {Promise}
 */
function loadGeoTargingApi() {
  const scriptSrc = '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js';

  return new Promise((resolve, reject) => {
    loadScript(scriptSrc, (err, script) => {
      if (err) {
        reject(err);
      } else {
        resolve(script);
      }
    });
  });
}

/**
 * @returns {Promise.<global.geoip2>}
 */
async function getGeoTargetingApi() {
  if (!global.geoip2) {
    await loadGeoTargingApi();
  }

  return Promise.resolve(global.geoip2);
}

/**
 * @returns {Promise.<geoTargetResponse>}
 */
export default async function getUserLocation() {
  const geoTargetingApi = await getGeoTargetingApi();

  return new Promise((resolve, reject) => {
    geoTargetingApi.city(resolve, reject);
  });
}
